export const SET_USER_FORMDATA = 'SET_USER_FORMDATA';
export const SET_USER_ONCHANGE = 'SET_USER_ONCHANGE';
export const RESET_USER_FORMDATA = 'RESET_USER_FORMDATA';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_IS_EDIT = 'SET_IS_EDIT';
export const SET_VERIFICATION_MAIL_LOADING_ON_USER = 'SET_VERIFICATION_MAIL_LOADING_ON_USER';
